import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { BaseFunnelStepConfigurationInterface } from 'modules/funnels/funnel/types/base-funnel-step-configuration-settings-interface';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useSWR from 'swr';
export function useBaseFunnelStepConfigurationSettings(funnelStepId) {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== funnelStepId) {
    t1 = () => `${FUNNELS_API}/steps/${funnelStepId}`;
    $[1] = funnelStepId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: funnelStepConfigurationSettings,
    mutate: mutateFunnelStepConfigurationSettings
  } = useSWR(t1, fetcher);
  let t2;
  if ($[3] !== funnelStepConfigurationSettings || $[4] !== mutateFunnelStepConfigurationSettings) {
    t2 = {
      funnelStepConfigurationSettings,
      mutateFunnelStepConfigurationSettings
    };
    $[3] = funnelStepConfigurationSettings;
    $[4] = mutateFunnelStepConfigurationSettings;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}